/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  accessToken: state => state.accessToken,
  user: state => state.user,
  accessDenied: state => state.accessDenied,
  passwordExpired: state => state.passwordExpired,
  userRoles: state => state.user ? state.user.roles || [] : [],
  isAuthenticated: state => {
    if (!state.user) {
      return false;
    }

    if (!state.accessToken) {
      return false;
    }

    return true;
  }
}
